export enum WellbeingRoutes {
    Root = "/mis-beneficios",
}
